export enum Status {
  ACTIVE = 'active',
  PENDING = 'pending',
  INACTIVE = 'inactive',
  EXPIRED = 'expired',
  DRAFT = 'draft',
  CANCELLED = 'cancelled',
  DELETED = 'deleted',
}
